export const APP_BAR_HEIGHT = "60px";
export const APP_SUBHEADER_HEIGHT = "56px";
export const APP_BAR_EXTENDED_HEIGHT = "98px";
export const ADMIN_NAVBAR_HEIGHT = "65px";
export const NAV_SIDEBAR_WIDTH = "324px";
